import { logger } from '@/services/LoggingService';

export interface ErrorState {
  // Error states
  sessionError: string | null;
  authError: string | null;
  storageBlocked: boolean;
}

export interface ErrorActions {
  // Auth error management
  setAuthError: (error: string | null) => void;
  clearAuthError: () => void;
  
  // Session error management
  setSessionError: (error: string | null) => void;
  
  // Storage management
  setStorageBlocked: (blocked: boolean) => void;
}

export const createErrorActions = (set: any, get: any) => ({
  // Auth error management
  setAuthError: (error: string | null) => {
    if (error) {
      logger.error('AuthStore', 'Setting auth error', { error });
    } else {
      logger.debug('AuthStore', 'Clearing auth error');
    }
    set({ authError: error });
  },

  clearAuthError: () => {
    logger.debug('AuthStore', 'Clearing auth error');
    set({ authError: null });
  },

  // Session error management
  setSessionError: (error: string | null) => {
    if (error) {
      logger.error('AuthStore', 'Setting session error', { error });
    } else {
      logger.debug('AuthStore', 'Clearing session error');
    }
    set({ sessionError: error });
  },
  
  // Storage management
  setStorageBlocked: (blocked: boolean) => {
    logger.info('AuthStore', 'Setting storage blocked status', { blocked });
    set({ storageBlocked: blocked });
  }
});